import IconButton from './IconButton';

export * from './IconButton';

export default IconButton;
